export const mutualOfOmahaMortgageBrentwoodTn = {
  name: "Mutual of Omaha Mortgage",
  locationLabel: "Brentwood, TN",
  address: {
    streetAddress: "9005 Overlook Blvd, Suite 118",
    addressLocality: "Brentwood",
    addressRegion: "TN",
    postalCode: "37027",
    addressCountry: "US",
  },
  locationPageUrl: "https://www.mutualmortgage.com/about-us/locations/brentwood-tn/",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=9005%20Overlook%20Blvd%20Suite%20118%20Brentwood%20TN%2037027",
};

